import { useEffect } from "react";
import { db } from "./firebase";
import { doc, updateDoc } from "firebase/firestore";

export default function PaymentSuccess() {
  useEffect(() => {
    const run = async () => {
      const userId = localStorage.getItem("pendingUserId");
      const plan = localStorage.getItem("pendingPlan");

      if (!userId || !plan) return;

      await updateDoc(doc(db, "vedai_users", userId), {
        plan: plan,
      });

      localStorage.removeItem("pendingUserId");
      localStorage.removeItem("pendingPlan");

      alert("Plan upgraded successfully!");
    };

    run();
  }, []);

  return <h2>Payment Successful... Activating Plan</h2>;
}